import { Component, Inject, OnDestroy, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Router } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { ShopService } from 'src/app/shared/api/shop.service';
import { RootService } from 'src/app/shared/services/root.service';
import { Meta } from '@angular/platform-browser';
import { OnlineProduct } from 'src/app/shared/interfaces/product';
import { CultureService } from 'src/app/shared/culture/culture.service';

@Component({
    selector: 'app-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit, OnDestroy{

    destroy$: Subject<void> = new Subject<void>(); 
    relatedProducts$: Observable<OnlineProduct[]>;
    columnLatestProducts: any[] = []; 
    columnLatestProducts2: any[] = []; 
    columnLatestProducts3: any[] = []; 
    loading1:boolean = true;
    loading2:boolean = true;
    loading3:boolean = true;
    form: FormGroup;
    hasSuggestions:boolean;
    suggestedProducts:any[];

    constructor(private shop: ShopService,  private fb: FormBuilder, private router:Router,
        private root: RootService, private meta: Meta,
        @Inject(PLATFORM_ID) private platformId: any,
        // The Express response, during a server render only. Typed loosely so the browser
        // build does not need Express's types.
        @Optional() @Inject(RESPONSE) private response: any,
        private culture: CultureService) { }
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.meta.removeTag("name='robots'");
    }

    ngOnInit(): void
    {
        // Rendered on the server, this page goes out as a real 404. Everything missing lands
        // here - an unknown url, and a product that was deleted, renamed or taken off the
        // storefront, whose details call now answers 404 - and it used to go out as a 200,
        // which told search engines the page was alive and kept a removed product indexed.
        if (isPlatformServer(this.platformId) && this.response)
        {
            this.response.status(404);
        }

        // Its own title - it kept the page before it in the tab - and noindex beside the 404, for anything that reads
        // the page rather than the status.
        this.root.setmeta(this.culture.t('page-not-found', 'Page Not Found'));
        this.meta.updateTag({ name: 'robots', content: 'noindex, follow' });

        this.form = this.fb.group({
            category: ['all'],
            query: [''],
        });

       this.shop.getFeaturedProducts("feature").pipe(takeUntil(this.destroy$)).subscribe(res =>
        {
            this.columnLatestProducts = res;
            this.loading1 = false;
        }); 

        this.shop.getFeaturedProducts("gadget-and-gears").pipe(takeUntil(this.destroy$)).subscribe(res =>
        {
            this.columnLatestProducts2 = res;
            this.loading2 = false;
        }); 

        this.shop.getFeaturedProducts("premium").pipe(takeUntil(this.destroy$)).subscribe(res =>
        {
            this.columnLatestProducts3 = res;
            this.loading3 = false;
        }); 

        this.form.get('category').valueChanges.pipe(   
            switchMap(res => 
            {
                let query = this.form.value.query ? this.form.value.query : undefined; 
                if (query) 
                { 
                    const categorySlug = res !== 'all' ? res : null; 
                    return this.shop.getSuggestions(query, categorySlug);
                }
    
                return of([]);
            }),
            takeUntil(this.destroy$),
        ).subscribe(products => {
            this.hasSuggestions = products.length > 0; 
            if (products.length > 0) {
                this.suggestedProducts = products;
            }
        });
    } 

    
    onEnter()
    { 
        if(!this.form.value.query || this.form.value.query.trim() == ''){
            return;
        }
        this.router.navigate(['/products'], { queryParams: { q:this.form.value.query } });
    }
}
